import React, { memo } from 'react';
import { Modal, Typography, Icon, CircularProgress } from '@ann/web-components';
import styled from 'styled-components';

const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
`;

const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 6px;
  background: ${(props) => props.theme.colors.surface || '#f5f5f5'};
`;

const AddConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedItems,
  isLoading,
}) => {
  const handleConfirm = async () => {
    await onConfirm?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="medium" width="618px">
      <Modal.Header />
      <div style={{ padding: '0 24px' }}>
        <Typography category="title" size="medium" weight="bold">
          You're about to add these files to this agent. Continue?
        </Typography>
      </div>
      <Modal.Body>
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '24px' }}>
            <CircularProgress size="xl" />
          </div>
        ) : (
          <ModalContentContainer>
            {selectedItems.length > 0 ? (
              selectedItems.map((item, index) => (
                <ItemWrapper key={`${item.type}-${item.uuid || item.vaultUuid || index}`}>
                  <Icon name={item.icon || (item.type === 'drive' ? 'folder' : 'description')} />
                  <Typography category="body" size="medium" weight="regular" color="body">
                    {item.name || 'Unnamed'}
                  </Typography>
                </ItemWrapper>
              ))
            ) : (
              <Typography category="body" size="medium" weight="regular" color="body">
                No items selected
              </Typography>
            )}
          </ModalContentContainer>
        )}
      </Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button 
          label="Cancel" 
          onClick={onClose} 
          type="secondary" 
          disabled={isLoading} 
        />
        <Modal.Button
          label="Yes, continue"
          onClick={handleConfirm}
          disabled={selectedItems.length === 0 || isLoading}
        />
      </Modal.Actions>
    </Modal>
  );
};

AddConfirmationModal.displayName = 'AddConfirmationModal';

export default memo(AddConfirmationModal);

